import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommentInterface } from '@vendasta/the-loop';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sales-common-loop-v2-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CommentComponent implements OnInit {
  @Input() comment: CommentInterface = {};
  @Input() iconSize = '40';
  username: string;

  iconDiameter$: Observable<string>;

  constructor(
    private readonly translateService: TranslateService,
    private readonly breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit(): void {
    this.calculateUsername();
    this.iconDiameter$ = this.breakpointObserver
      .observe(['(max-width: 600px)'])
      .pipe(map((result) => (result.matches ? '28' : '40')));
  }

  calculateUsername(): void {
    const names: string[] = [];
    if (this.comment.user) {
      if (this.comment.user.firstName) {
        names.push(this.comment.user.firstName);
      }
      if (this.comment.user.lastName) {
        names.push(this.comment.user.lastName);
      }
    }
    if (names.length === 0) {
      names.push(this.translateService.instant('FRONTEND.LOOP.UNKNOWN_USER'));
    }
    this.username = names.join(' ');
  }

  fromNow(date: Date): string {
    return moment(date).fromNow();
  }
}
